import { render, staticRenderFns } from "./MailStackIcon.vue?vue&type=template&id=0cdd5222&"
import script from "./MailStackIcon.vue?vue&type=script&lang=js&"
export * from "./MailStackIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports